import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../services/loader.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor{

  token: string;

  constructor(private readonly loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.show();
    let requestUpdated;
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    const {user_id} = userInfo;
    const tokenInfo = JSON.parse(sessionStorage.getItem('tokenInfo') || '{}');
    const { access_token } = tokenInfo;
    const isAssetRequest = req.url.includes('/assets/') && !req.url.includes('/bulk_create/assets/');
    const isMultipartEndpoint = [
      'api/pricebook/bulkupdate/upload-pricebook',
      'api/pricebook/bulkupdate/upload-reseller-cloudaccounts',
      'api/pricebook/bulkupdate/upload-reseller-cf',
      'api/pc/syndication/sync_catalog/blob_upload',
      'api/pc/syndication/cloudProviders'
    ].some(endpoint => req.url.includes(endpoint));
    const loginRequest = req.url.includes('api/master/login') || req.url.includes('api/master/resend-otp');
    if(isAssetRequest) {
      requestUpdated = req.clone({ 
        url: `${req.url}`,
        headers: new HttpHeaders({ 
          'Content-Type': 'application/json'
        }) 
      });
    } else if(loginRequest) {
      requestUpdated = req.clone({ 
        url: `${environment.baseURL}${req.url}`, 
        headers: new HttpHeaders({ 
          'Content-Type': 'application/json' 
        }) 
      });
    }
    else if (isMultipartEndpoint){
      requestUpdated = req.clone({ 
        url: `${environment.baseURL}${req.url}`, 
        headers: new HttpHeaders({ 
          'encrypt': 'multipart/form-data', 
          'X-User-Id': String(user_id), 
          'Authorization': `Bearer ${access_token}` 
        }) 
      });
    } else if(user_id !== null) {
      requestUpdated = req.clone({ 
        url: `${environment.baseURL}${req.url}`, 
        headers: new HttpHeaders({ 
          'Content-Type': 'application/json', 
          'X-User-Id': String(user_id),
          'Authorization': `Bearer ${access_token}` 
        }) 
      });
    } else {
      requestUpdated = req.clone({ 
        url: `${environment.baseURL}${req.url}`, 
        headers: new HttpHeaders({ 
          'Content-Type': 'application/json' 
        }) 
      });
    }
    const loaderExemptEndpoints = [
      'api/master/get-partner-migration/status/',
      'api/master/partner-migration',
      'api/master/retry-partnerOnboarding',
      'api/master/validate/migration',
      'api/master/create-user',
      'api/master/get-customer-migration/status',
      'api/master/validate/usermigration',
      '/cloudProviders',
      '/cbot-product-names',
      'api/pc/syndication/cbot_to_ccp_sync/trigger',
      'api/notifications/manage_user_alerts',
      'api/master/customer-creation-state/'
    ];
    
    const isBulkUpdateExcluded = (
      req.url.includes('api/pricebook/bulkupdate') &&
      ![
        'api/pricebook/bulkupdate/activity-monitor',
        'api/pricebook/bulkupdate/cf-progress-staging',
        'api/pricebook/bulkupdate/progress-staging',
        'api/pricebook/bulkupdate/reseller-progress-staging'
      ].includes(req.url)
    );
    
    const isLoaderExempt = loaderExemptEndpoints.some(endpoint => req.url.includes(endpoint)) || isBulkUpdateExcluded;
    if (isLoaderExempt) {
      this.loaderService.hide();
    }    
    
    return next.handle(requestUpdated).pipe(
      finalize(() => this.loaderService.hide()),
    );
  }
}